//import config from '../config';
import React,{Component} from "react";
import Cookies from "universal-cookie"
import {withRouter} from "react-router-dom";
import NumberFormat from 'react-number-format';
//import Mymodal from './modal';
import logo from "./images/loading.gif";
import BusyModal from './modalwait';
//import modallogo from "./images/loader.gif";

const axios = require("axios");
const ref = React.createRef();
const cookies=new Cookies();


class Profile extends Component{
    constructor(props)
    {
        super(props);
           this.state={ErrMsg2:"",input:{},myitems:[],padd:"",pmobile:"",pemail:"",bdisabled:false,isLoaded:false,inputkey:Date.now() ,errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",imagefile:config.Appdir+"/images/NoImage.png",filetoupload:null,filename:null,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone",defaultimage:config.Appdir+"/images/NoImage.png"};
           this.state={ErrMsg2:"",input:{},myitems:[],padd:"",pmobile:"",pemail:"",bdisabled:false,isLoaded:false,inputkey:Date.now() ,errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",imagefile:config.Appdir+"/images/NoImage.png",filetoupload:null,filename:null,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone",defaultimage:config.Appdir+"/images/NoImage.png"};
           this.handleChange = this.handleChange.bind(this);
           this.handleSubmit = this.handleSubmit.bind(this);
           this.handleImageUpload = this.handleImageUpload.bind(this);
    }
    
    handleImageUpload = async () => 
    {
        if(this.state.filetoupload !== null)
        {
            document.body.style.cursor ="wait";
            this.setState({ErrMsg2:<BusyModal/>});
            const formdata = new FormData() 
            formdata.append("image[]", this.state.filetoupload,this.state.filename);
            formdata.append("image[]",this.state.filetoupload,cookies.get("cnic"));
            try 
            {
                await axios.post(cookies.get("phpclass")+'/index.php/user/uploadImage/',
                formdata
                );
                this.setState({error:"Image has been successfully uploaded",errorcss:"labelsave",ErrMsg2:""});
                this.setState({inputkey:Date.now(),filetoupload: "",filename: "",browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});    
                document.body.style.cursor ="default";
                window.location.reload();
            } 
            catch (ex) 
            {
                document.body.style.cursor ="default";
                this.setState({error:ex,errorcss:"labelsave",ErrMsg2:""});
            }

        }
    }        

    Imagechange=(event)=>
    {
        if(event.target.files[0].size > 512000)
        {
            this.setState({error:"Error: File size exceeded",errorcss:"labelerror"});
            this.setState({inputkey:Date.now()});
        }
        else
        {
            this.setState({error:"",filetoupload: event.target.files[0],filename: event.target.files[0].name,imagefile:URL.createObjectURL(event.target.files[0]),browsecss:"labelnone",savecss:"labelblock",cancelcss:"labelblock"});
        }
    }
    Imagecancel=(event)=>
    {       
        this.setState({inputkey:Date.now(),error:"",filetoupload: "",filename: "",imagefile:this.state.defaultimage,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});
    }

    componentDidMount()
    {
        let id=cookies.get("LoginID");
//        alert(id);
        if(id.length > 1)
        {
            document.body.style.cursor="wait";
            let input = this.state.input;
            input["id"]=id;
            //this.setState({defaultimage:this.state.imagefile,input});
            let rn=Math.random(3);
            let cdir=cookies.get("phpclass");
                  this.setState({ logo2: cdir.substr(0,cdir.length-4)+'/images/' + cookies.get('LoginID') + '.jpg?ver=' + rn});
            let imgfile = cdir.substr(0,cdir.length-4)+"/images/"+id+".jpg?ver="+rn;
            this.setState({imagefile:imgfile});
        }
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/get_profile/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            console.log(response.data);
            document.body.style.cursor="default";
//            alert(response.data[0].pmobile);
            this.setState({isLoaded: true, myitems: response.data,pmobile:response.data[0].pmobile,padd:response.data[0].address2,pemail:response.data[0].pemail});
        })
        .catch(()=> {
            //handle error
           // this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});

        }); 
    }
    handleChange=(event)=> 
    {
        this.setState({imagefile:this.state.defaultimage});
    }
    //Change of input fields
    handleFiledsChange=(event)=>
    {
        let input = this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});
       
    }
    handleSubmit = (event)=>{
        this.setState({errorprofile:'',ErrMsg2:<BusyModal/>});
        event.preventDefault();
        if(this.validate())
        {
            this.setState({bdisabled:true});
            document.body.style.cursor="wait";
            axios({
               method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/changeprofile/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
                })

                .then((response)=> {
                    document.body.style.cursor="default";
                    if(response.data)
                    {   
                        this.setState({errorprofile:'Profile has been updated successfully.',ErrMsg2:"",errorcss:"labelsave",bdisabled:false});
                    }
                    else
                    {
                        this.setState({errorprofile:'Error: There might be a connection error. Please try later.',ErrMsg2:"",errorcss:"labelerror",bdisabled:false});
                    }
                })
                .catch((response)=> {
                    document.body.style.cursor="default";
                    this.setState({errorprofile:response.error,errorcss:"labelerror",bdisabled:false,ErrMsg2:""});
                }); 
        }
    }
  
    
    validate(){
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        //For email
      
        if (typeof input["pemail"] !== "undefined") {      
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(input["pemail"])) {
              isValid = false;
              errors["pemail"] = "Please enter valid email address.";
            }
        }                
        this.setState({errors: errors});
        return isValid;
    }        
    render(){
        let items = this.state.myitems;
        let isLoaded = this.state.isLoaded;
    
        if(!isLoaded) 
        {
            return (
                
                <div className="container1">            
                    <div className="center">
                          {this.state.ErrMsg}
                    </div>
                </div>
            )
        } 
        else 
        {
        return(
            items.map((result, i) => {
            return(
                <div className="containera1"  ref={ref}>
                    <br></br>                             
{/*}                    <span className="box-title">My Profile</span>*/}
                          
                    <div width="100%" align="center" scroll="hidden"   >
                        <div className="inner-profile">
                        <div className="inner-profile2">
                            <h4>My Profile</h4>
                            <br></br>
                            <form >
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Name:</label>
                                    <input type="text" name="name" className="form-control" value={result.name} disabled  />
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Father's Name:</label>
                                    <input type="text" name="fname" className="form-control" value={result.f_name} disabled/>
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Home address:</label>
                                    <input type="text" name="address" className="form-control" value={result.address} disabled/>
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Address other than home address (if any): </label>
                                    <input type="text" name="paddress" className="form-control" value={this.state.padd} onBlur={this.handleFiledsChange}/>
                                    {/*<small id="paddress" className="text-danger">{this.state.errors.paddress}</small>*/}
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Official contact number (if available):</label>
                                    <input type="text" name="mno" className="form-control" value={result.phone} disabled />
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Personal mobile number:</label>
                                    <NumberFormat format="###########"  name="pmobile" className="form-control" required size="12" value={this.state.pmobile} onBlur={this.handleFiledsChange} />
                                    {/*<small id="passwordHelp" className="text-danger">{this.state.errors.pmno}</small>*/}
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Official email address:</label>
                                    <input type="email" name="email" className="form-control" value={result.email} disabled/>
                                </div>
                                <div className="form-group row">
                                    <label style={{textAlign:"left"}}>Other/Personal email address:</label>
                                    <input type="email" name="pemail" className="form-control" value={this.state.pemail} onBlur={this.handleFiledsChange}/>
                                    {/*<small id="passwordHelp" className="text-danger">{this.state.errors.pemail}</small>*/}
                                </div>
                                <div className={this.state.errorcss}>{this.state.errorprofile}</div>
                                    <button type="submit" className="btn btn-dark" disabled={this.state.bdisabled} onClick={this.handleSubmit} >Submit</button>
                            </form>
                        </div>            

                        <div className="inner-profile3" >
                            <img src={this.state.imagefile}  onError={this.handleChange} style={{width:"170px",height:"185px",paddingTop:"0px",marginTop:"25px",Left:"60%",border: "1px solid #555"}} alt=""></img>
                            <label style={{fontSize:"8pt",width:"173px",textAlign:"center"}}>Max size=512KB (jpg)</label>
                            <label className={this.state.browsecss}>
                            <input type="file" name="file" key={this.state.inputkey} accept="image/jpg" className="upload" onChange={this.Imagechange}/>
                            <span>Browse an image</span>
                            </label>

                            <label className={this.state.savecss}>
                            < button onClick={this.handleImageUpload}>
                                <span>Save image</span>
                            </button>
                            </label>
                            <label className={this.state.cancelcss}>
                            <button  onClick={this.Imagecancel}>
                                <span>Cancel</span>
                            </button>
                            </label>
                            <label className="labelerror" >
                                <span className={this.state.errorcss}>{this.state.error}</span>
                            </label>
                        </div>
                    </div>
                </div>
                {this.state.ErrMsg2}
            </div>
        )})
    )}
}}
export default withRouter(Profile);